<template>
<ScreenLayout :leftVisible="false" uniform-colour>
    <v-app-bar slot="header" flat dark dense color="blue">       
            <v-toolbar-title >John and June Citizen</v-toolbar-title>
            <v-spacer></v-spacer>
        
            <ToolbarSearch @search="search" />
            <v-menu bottom left :nudge-width="200">
                <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" dark>
                    <v-icon>more_vert</v-icon>
                </v-btn>
                </template>
                <v-list>           
                    <v-list-item @click="page.saveAll()"> 
                        <v-list-item-title>Save All</v-list-item-title>
                    </v-list-item>            
                </v-list>
            </v-menu>
        </v-app-bar> 

        <div class="raised-desktop">
            <Flow :id="flowId" />
        </div> 

        <div slot="right" class="raised-desktop white-background">
            <StepDesigner />
            <FlowActivity />
        </div> 

        <v-dialog max-width="300" v-model="makingActivity" :fullscreen="$vuetify.breakpoint.xsOnly" transition="v-fade-transition" persistent>
            <v-card class="pa-4">
                <v-textarea id="activityDescription" v-model="page.newComment"></v-textarea>
            </v-card>
        </v-dialog>
</ScreenLayout>

<!-- <div style="height:100%;display:flex;flex-direction:column">
    <div style="flex-shrink:1">
        
    </div>
    <div class="flow-layout" style="flex-grow:1;overflow-y:auto;">
        <div class="flow-layout-main" style="flex-grow:1;height:100%;overflow-y:scroll;overflow-x:hide">
            <Flow :id="flowId" />      
        </div>
        <div class="flow-layout-right">
            <div class="pa-2">
                <StepDesigner />
                <FlowActivity />
            </div>
        </div>
    </div>

    <v-dialog max-width="300" v-model="makingActivity" :fullscreen="$vuetify.breakpoint.xsOnly" transition="v-fade-transition" persistent>
        <v-card class="pa-4">
            <v-textarea id="activityDescription" v-model="page.newComment"></v-textarea>
        </v-card>
    </v-dialog>
</div> -->


</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'
import Flow from './Flow'
import StepDesigner from './ui/StepDesigner'
import {addDays} from 'date-fns'
import DataHelpers from '@/helpers/DataHelpers'
import Firestore from '@/data/Firestore'
import ToolbarSearch from '@/ui-elements/ToolbarSearch'
import Vue from 'vue'
import Utilities from '@/helpers/Utilities'
import AlertHelpers from '@/helpers/AlertHelpers'
import FlowHelpers from './FlowHelpers'
import FlowActivity from './FlowActivity'

export default {
    name: 'Workflow',
    components: {ScreenLayout, Flow, ToolbarSearch, StepDesigner, FlowActivity},
    props: {
        flowId: String,
    },
    data() {
        return {
            page: {

                newComment: null,
                activeStep: null,
                allFlows: [], // this.mockFlows(),

                activities: [],

                showActivity: function(desc) {
                    this.newComment = desc
                    Utilities.focusById('activityDescription')
                },

                getAllVisibleSteps() {
                    return this.getAllSteps(null, null, {visible: true})
                },

                getAllSteps(workflowId, allSteps, options={}) {
                    if(!allSteps)
                        allSteps = []
                    let workflow
                    
                    if(workflowId)
                        workflow = this.allFlows.find(o => o._id == workflowId)
                    else
                        workflow = this.allFlows.find(o => o.name == 'root')

                    workflow.steps.forEach(step => {
                        allSteps.push(step)
                        if(step.children) {
                            step.children.forEach(childId => {
                                // debugger
                                if(!options.visible || step.expanded)
                                    this.getAllSteps(childId, allSteps, options)
                            })
                        }
                    })
                    return allSteps
                },
                
                getSelectedSteps() {
                    let allSelected = []
                    this.allFlows.forEach(flow => {
                        const selectedSteps = flow.steps.filter(o => o._selected)
                        allSelected = [...allSelected, ...selectedSteps]
                    })
                    return allSelected
                },
                unselectAll() {
                    this.getSelectedSteps().forEach(step => {
                        Vue.delete(step, '_selected')
                    })
                },
                saveAll() {
                    this.allFlows.forEach(flow => {
                        FlowHelpers.saveFlow(flow)
                    })
                    AlertHelpers.showAlert('Saved Everything')
                },

            },
            sampleFlows: [
       
            ],
            flow: {}
        }
    },
    provide: function() {
        return {
            '$page': this.page,
        }
    },
    computed:{
        makingActivity: {
            get: function() {
                return Boolean(this.page.newComment)
            },
            set: function(newVal) {
                if(!newVal)
                    this.page.newComment = null
            }
        }
    },

    methods: {

    search() {
        console.log('searching...')
    },

    mockFlows() {

        return [
            {
                _id: 'BiI1r9ST77HjOeOIlbQ4',
                name: 'root',
                title: 'Home Loan Demo',
                steps: [ 
                    {
                        _id: Firestore.getId(),
                        title: 'Lead',
                        name: 'lead',
                        type: 'task',
                        value: null,
                        complete: true,                
                    },
                    {
                        _id: Firestore.getId(),
                        title: 'Loan',
                        name: 'loan',
                        type: 'task',
                        value: null,
                        complete: true,                  
                    },
                    {
                        _id: Firestore.getId(),
                        title: 'Pricing and Valuation',
                        description: 'Pricing Ordered, Pricing Back, Valuation Ordered',
                        name: 'pricing_valuation',
                        type: 'task',
                        value: null,
                        children: ['YflNLuJ7Kby867fLuYjT'],   
                        due: new addDays(new Date(), 3),
                        assigned: DataHelpers.getUser(),
                        percent: 50,
                    },
                    {
                        _id: Firestore.getId(),
                        title: 'Submission',
                        name: 'submission',
                        type: 'task',
                        value: null,
                        percent: 30,                   
                    },
                    {
                        _id: Firestore.getId(),
                        title: 'Conditional',
                        name: 'conditional',
                        type: 'task',
                        value: null                    
                    },
                    {
                        _id: Firestore.getId(),
                        title: 'Formal',
                        name: 'formal',
                        type: 'task',
                        value: null                    
                    },
                    {
                        _id: Firestore.getId(),
                        title: 'Settled',
                        name: 'settled',
                        type: 'task',
                        value: null                    
                    },
                ]
            },
            {
                _id: 'YflNLuJ7Kby867fLuYjT',
                name: 'pricing',
                steps: [
                    {
                        _id: Firestore.getId(),
                        title: 'Pricing Ordered',
                        name: 'pricing_ordered',
                        type: 'task',
                        value: null,
                        complete: true,                  
                    },                    
                    {
                        _id: Firestore.getId(),
                        title: 'Pricing Back',
                        name: 'pricing_back',
                        type: 'task',
                        value: null,                   
                    },                    
                    {
                        _id: Firestore.getId(),
                        title: 'Valuation Ordered',
                        name: 'val_ordered',
                        type: 'task',
                        value: null,
                        complete: true,
                        children: ['0bccrQE8PRwLMoTq1bUx'],
                        description: '$400,000, Trentons Valuation Services',
                        important: 3
                    },                    
                    {
                        _id: Firestore.getId(),
                        title: 'Valuation Back',
                        name: 'val_back',
                        type: 'task',
                        value: null,
                        due: new Date(),                 
                    },                    
                ]
            },
            {
                _id: '0bccrQE8PRwLMoTq1bUx',
                name: 'val_details',
                steps: [
                    {
                        _id: Firestore.getId(),
                        title: 'Val Estimate',
                        name: 'val_estimate',
                        type: 'text',
                        value: '$400,000',
                        important: 1,
                    },                                        
                    {
                        _id: Firestore.getId(),
                        title: 'Valuer Details',
                        name: 'valuer',
                        type: 'text',
                        value: 'Trentons Valuation Services',
                    },                                        
                    {
                        _id: Firestore.getId(),
                        title: 'Full Valuation',
                        name: 'full_val',
                        type: 'true-false/switch',
                        value: null,
                    },                                        
                    {
                        _id: Firestore.getId(),
                        title: 'Contract of Sale',
                        name: 'cos',
                        type: 'file/upload',
                        value: null,
                    },                                        
                    {
                        _id: Firestore.getId(),
                        title: 'Sent COS',
                        name: 'sent_cos',
                        type: 'true-false/checkbox',
                        value: null,
                        important: 2
                        ,
                    },                                        
                    {
                        _id: Firestore.getId(),
                        title: 'Sent Lender Info',
                        name: 'sent_lender_info',
                        type: 'true-false/checkbox',
                        value: null,
                    },                                        
                    {
                        _id: Firestore.getId(),
                        title: 'Checked purchase amount',
                        name: 'purchase_amt',
                        type: 'true-false/checkbox',
                        value: null,
                    }, 
                    {
                        _id: Firestore.getId(),
                        title: 'Due Back',
                        name: 'due_back',
                        type: 'text',
                        value: '14 October',
                    },                                                            
                ]
            }            

        ]

        

    }    



    },

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.v-toolbar {
    border-radius:0!important;
}
</style>


// WEBPACK FOOTER //
// Workflow.vue?1c598ed1